
import { AccountController } from "@/app/ui/controllers/AccountController";
import { Options, Vue, prop } from "vue-class-component";

class Props {
  flag = prop<string>({
    type: String,
    default: "",
  });
  regionName = prop<string>({
    type: String,
    default: "",
  });
  isStiDest = prop<boolean>({
    type: Boolean,
    default: false
  })
}

@Options({})
export default class BagIcon extends Vue.with(Props) {
  get isAccountForeign() {
    return AccountController.accountData?.accountIsForeign
  }
}
